import store from './store'
import Axios from 'axios';

//subscribe gets called after every mutation, and do something after this mutation is done
store.subscribe((mutation) => {
    // console.log(mutation)
    switch (mutation.type) {
        case 'auth/SET_TOKEN':
            if (mutation.payload) {
                // console.log(mutation)
                // console.log(mutation.payload)
                Axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
                localStorage.setItem('token', mutation.payload)
            } else {
              Axios.defaults.headers.common['Authorization'] = null
              localStorage.removeItem('token')
            }
            break;
        case 'auth/SET_CLIENT_DATA':
            if (mutation.payload) {
                localStorage.setItem('customer_id', mutation.payload.id)
            } else {
                localStorage.removeItem('customer_id')
            }
            break;
    }
})
